import { deleteIn } from "common/utils/objectUtils";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

const defaultExteriorMaterialSettings: any = {
  type: "EXTERIOR_MATERIAL_SETTINGS",
  name: "Default",
  palettes: ["Elliott_H00"],
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_18: DocMigration = {
  maxSchemaVersion: "0.0.18",
  apply(json: any) {
    if (json.params) {
      for (const key of Object.keys(json.params)) {
        if (key.endsWith("[exteriorPalette]") || key.endsWith(".exteriorPalette")) {
          json = deleteIn(json, ["params", key]);
        }
      }
    }

    if (!json.tables) {
      json.tables = {};
    }

    if (!json.tables.settings) {
      json.tables.settings = {};
    }

    if (json.elevations) {
      for (const elevationId in json.elevations) {
        const elevation = json.elevations[elevationId];

        if (!elevation.settingsOverride) {
          elevation.settingsOverride = {};
        }

        if (!elevation.settingsOverride.exteriorMaterials) {
          const settingsId = uid();
          elevation.settingsOverride.exteriorMaterials = settingsId;
          json.tables.settings[settingsId] = defaultExteriorMaterialSettings;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_18;
